import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-footer',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <footer class="admin-footer">
      <div class="footer-content">
        <span>&copy; {{ currentYear }} GardeKids. {{ 'APP_FOOTER.RIGHTS' | translate }}</span>
      </div>
    </footer>
  `,
  styles: [`
    :host {
      display: block;
    }
    .admin-footer {
      background: #f5f5f5;
      border-top: 1px solid #e0e0e0;
      padding: 12px 24px;
      text-align: center;
      font-size: 13px;
      color: #888;
      margin-left: 260px;
      transition: margin-left 0.3s;
    }
    .footer-content {
      max-width: 100%;
    }
    .footer-content span {
      display: inline-block;
      line-height: 1.45;
      word-break: normal;
      overflow-wrap: anywhere;
    }
    :host-context(.side-closed) .admin-footer,
    :host-context(.is-collapsed) .admin-footer {
      margin-left: 65px;
    }
    :host-context(.rtl) .admin-footer {
      margin-left: 0;
      margin-right: 260px;
    }
    :host-context(.rtl.side-closed) .admin-footer,
    :host-context(.rtl.is-collapsed) .admin-footer {
      margin-left: 0;
      margin-right: 65px;
    }
    @media (max-width: 1024px) {
      .admin-footer,
      :host-context(.side-closed) .admin-footer,
      :host-context(.is-collapsed) .admin-footer,
      :host-context(.rtl) .admin-footer,
      :host-context(.rtl.side-closed) .admin-footer,
      :host-context(.rtl.is-collapsed) .admin-footer {
        margin-left: 0;
        margin-right: 0;
        padding: 14px 16px 20px;
        text-align: center;
      }
    }
  `]
})
export class AdminFooterComponent {
  currentYear = new Date().getFullYear();
}
